module.exports = __webpack_public_path__ + "static/img/kefon_logo.3ac517c.png";


//////////////////
// WEBPACK FOOTER
// ./static/kefon_logo.png
// module id = 0vj0
// module chunks = 1